export const ACCOUNT_LOGO_CONFIG = {
  'ab-inbev': {
    width: 98,
    height: 18,
  },
  ace: {
    width: 56,
    height: 22,
  },
  bacardi: {
    width: 96,
    height: 22,
  },
  bayer: {
    width: 24,
    height: 24,
  },
  bimbo: {
    width: 53,
    height: 24,
  },
  'coca-cola': {
    width: 65,
    height: 24,
  },
  cosnova: {
    width: 105,
    height: 12,
  },
  coty: {
    width: 57,
    height: 22,
  },
  danone: {
    width: 51,
    height: 24,
  },
  'demo-cmi': {
    width: 176,
    height: 18,
  },
  'de-longhi': {
    width: 65,
    height: 20,
  },
  dentsu: {
    width: 176,
    height: 18,
  },
  deoleo: {
    width: 76,
    height: 18,
  },
  ferrero: {
    width: 122,
    height: 16,
  },
  flywheel: {
    width: 96,
    height: 22,
  },
  groupm: {
    width: 116,
    height: 18,
  },
  hartmann: {
    width: 52,
    height: 22,
  },
  heineken: {
    width: 101,
    height: 18,
  },
  herdez: {
    width: 69,
    height: 14,
  },
  iansa: {
    width: 44,
    height: 24,
  },
  jde: {
    width: 27,
    height: 24,
  },
  kelloggs: {
    width: 63,
    height: 22,
  },
  lego26: {
    width: 24,
    height: 24,
  },
  loewe: {
    width: 62,
    height: 14,
  },
  lvmh: {
    width: 67,
    height: 16,
  },
  mahou: {
    width: 82,
    height: 20,
  },
  nestle: {
    width: 67,
    height: 18,
  },
  osborne: {
    width: 104,
    height: 16,
  },
  pepsico: {
    width: 86,
    height: 12,
  },
  perfetti: {
    width: 74,
    height: 15,
  },
  pilgrims: {
    width: 40,
    height: 24,
  },
  'prime-drinks': {
    width: 71,
    height: 22,
  },
  redbull: {
    width: 100,
    height: 16,
  },
  samsung: {
    width: 104,
    height: 16,
  },
  'skii-jp': {
    width: 36,
    height: 15,
  },
  'spectrum-brands': {
    width: 135,
    height: 16,
  },
  virbac: {
    width: 105,
    height: 18,
  },
  walmart: {
    width: 85,
    height: 16,
  },
  wpp: {
    width: 116,
    height: 18,
  },
} as const
